<script>
  import LandingPageHero from "./LandingPageHero.svelte";

  export let title;
  export let featuredImage;
  export let logo;
  export let cta;
  export let links;
  export let bgColor;

  // MVA NOTE: backgroundClasses is specific to background image with P44 on beach
  const backgroundClasses =
    "bg-no-repeat bg-cover md:h-screen h-[850px] bg-[left_calc(10%)_top_calc(0%)] min-[500px]:h-[830px] min-[500px]:bg-[left_calc(0%)_top_calc(76%)] min-[590px]:h-[1000px] md:bg-[right_calc(0%)_top_calc(10%)] lg:h-1366";

  const containerClasses = "py-48 lg:py-72 px-24 lg:px-230";
  const logoClasses = "max-h-[90px] lg:max-h-[120px]";
  const mobileTextSize = "text-size-20";
</script>

<LandingPageHero
  variant="fixed-background"
  {backgroundClasses}
  {containerClasses}
  {logoClasses}
  {mobileTextSize}
  {title}
  {featuredImage}
  {logo}
  {cta}
  {links}
  {bgColor}
/>
